import React, { useEffect, useState, useCallback }  from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";

import "./index.scss";

import NoDataFound from "../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../ui/SkeletonLoader";
import CustomTooltip from "../../../../../ui/Tooltip";

import { viewMoreDownArrowIcon } from "../../../../../../utils/icons";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getTopVulnerabilities } from "../../../../../../store/actions/thirdPartyRiskAction";

const TopVulnerabilities = () =>{

    const topVulnerabilitiesStatsResponse = useSelector((state) => state.thirdPartyRisk.topVulnerabilitiesStats)

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [topVulnerabilitiesLoading, setTopVulnerabilitiesLoading] = useState(false);
    const [topVulnurabitiesStats, setTopVulnerabilitiesStats] = useState(null);
    const [showViewAll, setShowViewAll] = useState(false)

    const fetchTopVulnerabilities = useCallback(()=>{
        setTopVulnerabilitiesLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getTopVulnerabilities(params))
    },[dispatch, organizationId, domainId, scanId])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchTopVulnerabilities();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchTopVulnerabilities])

    useEffect(()=>{        
        if(topVulnerabilitiesStatsResponse !== null) {
            setTopVulnerabilitiesLoading(false);
            setTopVulnerabilitiesStats(topVulnerabilitiesStatsResponse)
        }
    },[topVulnerabilitiesStatsResponse])

    return (
        <div className="bg-white-with-shadow p-4 h-100">
            {
                topVulnerabilitiesLoading ?
                <SkeletonLoader type={"line"} count={7} currentPage={"digitalfootprint"} />
                :
                <motion.div
                    className="h-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="top-vulnerability-container">
                        <h4 className="top-vulnerability-heading">Top Vulnerability</h4>
                        <div className={`vulnerability-list ${showViewAll ? "active" : ""}`}>
                            {
                                topVulnurabitiesStats?.stats?.top_vulnerabilities.length > 0 ?
                                topVulnurabitiesStats?.stats?.top_vulnerabilities.map((data, index)=>{
                                    return (
                                        <div className="vulnerability-content" key={index}>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="vulnerability-details-container d-flex align-items-center gap-2">
                                                        <div className="vulnerability-number"><p>{index < 9 ? `0${index+1}` : index+1}</p></div>
                                                        <div className="vulnerabilty-name">
                                                            <h2>{data?.name}</h2>
                                                            {data?.description !== null && data?.description !== "" && data?.description.length > 60 ?
                                                                <CustomTooltip content={data?.description} position={"top"}>
                                                                    {data?.description.slice(0, 60) + "..." }
                                                                </CustomTooltip>
                                                                :
                                                                <p>{data?.description}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={3}>
                                                    <div className="vulnerability-name"><p>{data?.category}</p></div>
                                                </Col>
                                                <Col lg={3}>
                                                    <div className={`vulnerability-status ${data.severity}`}>{data?.severity}</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    )
                                })
                                :
                                <NoDataFound noDataText={topVulnurabitiesStats?.description} />
                            }
                        </div>
                        {topVulnurabitiesStats?.stats?.top_vulnerabilities.length > 4 && <div className="view-more-div d-flex align-items-center justify-content-center p-2">
                            <p className="m-0 cursor-pointer" onClick={()=>{setShowViewAll(!showViewAll)}}>{showViewAll ? "View Less" : "View More"} <span className={`${showViewAll ? "active" : ""}`}>{viewMoreDownArrowIcon()}</span></p>
                        </div>}
                    </div>
                </motion.div>
            }
        </div>
    )
}

export default TopVulnerabilities;